module["exports"] = [
  "Əhmədov",
  "Ələkbərov",
  "Əliyev",
  "Vəliyev",
  "Soltanov",
  "Quliyev",
  "Məmmədov",
  "Xəlilov",
  "Nəzərov",
  "Rəhimov"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/az/name/male_last_name.js
// module id = 1116
// module chunks = 1